<template>
  <!-- 车辆信息 -->
  <Drawer
    title="标签添加与移除"
    :closable="true"
    v-model="openLabel"
    draggable
    width="700"
    class="my-drawer"
  >
    <Dropdown v-for="(item, index) in carlabelList" :key="index">
      <Button style="margin-right: 10px" type="primary">{{ item.name }}</Button>
      <template #list>
        <DropdownMenu>
          <DropdownItem
            ><span @click="TagAdd(item.name, index)"
              >批量添加</span
            ></DropdownItem
          >
          <DropdownItem
            ><span @click="TagDel(item.name, index)"
              >批量移除</span
            ></DropdownItem
          >
        </DropdownMenu>
      </template>
    </Dropdown>
    <table id="labelTable">
      <thead>
        <tr>
          <td style="width: 150px">车牌号</td>
          <td style="width: 200px">单位名称</td>
          <td>标签</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in carlist" :key="index">
          <td style="width: 150px">{{ item.carNo }}</td>
          <td style="width: 200px">{{ item.groupName }}</td>
          <td>
            <Tag
              v-for="(x, index1) in item.labelList"
              :key="index1"
              :name="x"
              color="primary"
              closable
              @on-close="handleClose2(item, index1)"
              >{{ x }}</Tag
            >
          </td>
        </tr>
      </tbody>
    </table>
    <Button type="primary" @click="save" style="float: right">提交保存</Button>
  </Drawer>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      openLabel: false,
      carlist: [],
      carlabelList: [],
    };
  },
  methods: {
    reachData(v) {
      this.carlist = v;
      this.openLabel = true;
    },
    getDictionary() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: "/dictionary/item",
        data: {
          keyword: "carLabel",
        },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        console.log(res);
        this.carlabelList = JSON.parse(res.data.data.value);
      });
    },
    setColor(v) {
      for (const i in this.carlabelList) {
        if (v == this.carlabelList[i].name) {
          return this.carlabelList[i].color;
        }
      }
    },
    handleClose2(item, index) {
      item.labelList.splice(index, 1);
    },
    TagAdd(name, index) {
      for (const i in this.carlist) {
        if (this.carlist[i].labelList.indexOf(name) == -1) {
          this.carlist[i].labelList.push(name);
        }
      }
    },
    TagDel(name) {
      for (const i in this.carlist) {
        var index = this.carlist[i].labelList.indexOf(name);
        if (index > -1) {
          this.carlist[i].labelList.splice(index, 1);
        }
      }
    },
    save() {
      var tt = this.carlist;
      var dd = [];
      for (let i = 0; i < tt.length; i++) {
        var obj = {
          carId: tt[i].carId,
          labelList: tt[i].labelList,
        };
        dd.push(obj);
      }
      console.log(dd);
      this.utils.loading(this, "保存中");
      axios({
        method: "post",
        url: axios.dm + "/car/saveLabel",
        data: {
          labelConfig: dd,
        },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.openLabel = false;
          this.$emit("labelSaveFinish");
        }
      });
    },
  },
  mounted() {
    this.getDictionary();
  },
};
</script>
<style lang="">
#labelTable {
  margin-top: 20px;
  height: calc(100% - 110px);
  margin-bottom: 20px;
  border: solid #ccc;
  border-width: 4px 0;
}
#labelTable tr {
  width: 100%;
}
#labelTable th {
  line-height: 3;
}

#labelTable td {
  line-height: 2;
}

#labelTable thead,
#labelTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
#labelTable thead {
  width: calc(100% - 1em);
}
#labelTable tbody {
  display: block;
  height: calc(100% - 32px);
  overflow-y: auto;
  border-top: solid 1px #ccc;
  padding-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/information/carLabel.vue